import { featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedSection() {
  return (
    <section id="latest" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
              编辑精选
            </h2>
            <p className="text-sm text-foreground-600">编辑部精心挑选的高品质漫画推荐</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}